module.exports = __webpack_public_path__ + "img/second.94fca4ab.png";